import { createContext } from 'react'

const RncActionContext = createContext()

export default RncActionContext
